import { I18n } from '@calendly/i18n'
import { marked } from 'marked'

const removeActionItems = (topics) => {
  if (!topics || !Array.isArray(topics)) return []
  const headerIndex = topics.findIndex((topic) => topic.text === '**Meeting Action Items**\n')
  if (headerIndex === -1) return topics
  return topics.slice(0, headerIndex - 1)
}

const removeTimestamps = (text) => text.replace(/\s*\([^()]*:[^()]*\)\n?/g, '\n')

const isValidSummariesProperty = (summaries, property, minimumLength) => summaries
  && summaries[property]
  && Array.isArray(summaries[property])
  && summaries[property].length >= minimumLength

const getFormattedSummary = (summaries, isAttendeeEmail = false, followupSummary = null) => {
  if (isAttendeeEmail) {
    return (followupSummary && followupSummary.followupSummary) || ''
  }

  if (!isValidSummariesProperty(summaries, 'summary', 1)) {
    return ''
  }

  return summaries.summary
    .map((item) => marked.parse(item.text))
    .join('')
    // Remove all HTML <br> tags (with or without closing slash, case-insensitive)
    .replace(/<br\s*\/?>/gi, '')
}

const getFormattedActionItems = (summaries) => {
  if (!isValidSummariesProperty(summaries, 'actionItems', 2)) {
    return ''
  }

  return `<h3>Action Items</h3> ${summaries.actionItems
    .map((item) => marked.parse(item.text)).join('')}`
}

const getFormattedDiscussion = (summaries) => {
  if (!isValidSummariesProperty(summaries, 'topics', 1)) {
    return ''
  }

  const parsedDiscussion = removeActionItems(summaries.topics)
  return parsedDiscussion
    .map((topic) => marked.parse(removeTimestamps(topic.text)))
    .join('')
    // Remove all HTML <br> tags (with or without closing slash, case-insensitive)
    .replace(/<br\s*\/?>/gi, '')
}


export const createEmailBody = (event, name, attendees, summaries) => {
  const top = I18n.t('publisher.meeting_intelligence.share.default_email_body', { event, name })

  const bottom = `
<h3>Notes</h3>
${attendees.length > 0 ? `<b>Attendees:</b> ${attendees.join(', ')}<br />` : ''}
${getFormattedSummary(summaries)}
<br />
${getFormattedActionItems(summaries)}
<br />
<h3>Discussion</h3>
${getFormattedDiscussion(summaries)}`

  return `${top}<br /><br />${bottom}`
}

export const createAttendeeEmailBody = (event, name, attendees, summaries, followupSummary) => {
  const isOneAttendee = attendees.length === 1
  const intro = isOneAttendee ? ` ${attendees[0]}` : ''
  const top = I18n.t('publisher.meeting_intelligence.share.default_attendee_email_body_la', { event, name, intro })

  const bottom = `
<h3>Notes</h3>
${getFormattedSummary(summaries, true, followupSummary)}
<br />
${getFormattedActionItems(summaries)}
<br />
<h3>Discussion</h3>
${getFormattedDiscussion(summaries)}`

  return `${top}<br /><br />${bottom}`
}

// Create a list of attendee names and emails from event memberships and invitees
// Event membership names are the hosts of the meeting
export const parseInvitees = (event, invitees) => {
  // If there are no event memberships, this is a non-Calendly meeting
  if (!event) {
    const inviteeEmails = invitees
      .filter((invitee) => invitee.email !== null)
      .map((invitee) => invitee.email)

    return [[], inviteeEmails]
  }

  if (!Array.isArray(invitees) || invitees.length === 0) {
    return [[], []]
  }

  return invitees.reduce(
    (acc, invitee) => {
      if (invitee && invitee.name && invitee.email) {
        acc[0].push(invitee.name)
        acc[1].push(invitee.email)
      }
      return acc
    },
    [[], []]
  )
}
